/* Custom Drops - promo rail drift.
   Continuous transform-based scroll rather than snap-scrolling, so the
   section always looks alive. The track is rendered twice, so once we've
   travelled the width of the first copy we reset to 0 and the loop is
   invisible. Pauses on hover, on touch and when the tab is hidden.
   Arrows nudge the offset by one card. */
(function () {
  function init(section) {
    if (section.dataset.cdpsInit === '1') return;
    section.dataset.cdpsInit = '1';

    var track = section.querySelector('[data-cdps-track]');
    var viewport = section.querySelector('[data-cdps-viewport]');
    if (!track || !viewport) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = parseFloat(getComputedStyle(section).getPropertyValue('--cdps-speed')) || 30;
    var offset = 0;
    var paused = reduce;
    var last = null;

    function half() {
      // Track holds two identical copies; loop point is halfway.
      return track.scrollWidth / 2;
    }

    function cardStep() {
      var card = track.querySelector('.cdps__card');
      if (!card) return 340;
      var gap = parseFloat(getComputedStyle(track).gap) || 22;
      return card.getBoundingClientRect().width + gap;
    }

    function apply() {
      track.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
    }

    function wrap() {
      var h = half();
      if (h <= 0) return;
      while (offset >= h) offset -= h;
      while (offset < 0) offset += h;
    }

    function frame(now) {
      if (last === null) last = now;
      var dt = (now - last) / 1000;
      last = now;
      if (!paused) {
        offset += speed * dt;
        wrap();
        apply();
      }
      requestAnimationFrame(frame);
    }

    if (!reduce) requestAnimationFrame(frame);

    function nudge(dir) {
      offset += dir * cardStep();
      wrap();
      track.style.transition = 'transform .45s cubic-bezier(.2,.7,.3,1)';
      apply();
      setTimeout(function () { track.style.transition = ''; }, 460);
    }

    var prev = section.querySelector('[data-cdps-prev]');
    var next = section.querySelector('[data-cdps-next]');
    prev && prev.addEventListener('click', function () { nudge(-1); });
    next && next.addEventListener('click', function () { nudge(1); });

    if (!reduce) {
      viewport.addEventListener('mouseenter', function () { paused = true; });
      viewport.addEventListener('mouseleave', function () { paused = false; });
      viewport.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      viewport.addEventListener('touchend', function () { paused = false; }, { passive: true });
      viewport.addEventListener('focusin', function () { paused = true; });
      viewport.addEventListener('focusout', function () { paused = false; });
      document.addEventListener('visibilitychange', function () {
        paused = document.hidden;
        last = null;
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-cdps]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
